import { register } from "@rill/loader";

register(
  {
    name: "admin_royaltyReports",
    meta: ["report"],
  },
  async ({ api }) => {
    const res = await api("report", {
      query: {
        type: "royalty",
        limit: false,
        sort: { name: 1 },
      },
    });
    return await res.json();
  }
);
